import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import Card from "../common/Card";

const WordPressGuideBanner = () => {
  const navigate = useNavigate();

  return (
    <Card className="mb-6 bg-gradient-to-r from-indigo-50 to-sky-50 border-indigo-100">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex items-start gap-4">
          <div className="hidden sm:flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white shadow-sm">
            <Icon icon="mdi:wordpress" className="text-3xl text-[#21759b]" />
          </div>
          <div>
            <h2 className="text-lg md:text-xl font-semibold text-text-dark">
              New here? Learn how to use the WordPress plugin
            </h2>
            <p className="text-sm text-text-secondary mt-1 max-w-2xl">
              Our plugin isn't listed on the WordPress.org directory yet —
              download it below, then follow the step-by-step guide (with
              screenshots) to install it and connect your WordPress site to
              SentryPrime.
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          {/* <a
            href="/downloads/ada-compliance-scanner.zip"
            download
            className="inline-flex items-center justify-center gap-2 self-start md:self-auto bg-white text-primary border border-primary/30 px-5 py-3 rounded-lg font-semibold text-sm hover:bg-primary/5 transition-colors"
          >
            <Icon icon="mdi:download" className="text-lg" />
            Download Plugin (.zip)
          </a> */}

          <button
            type="button"
            onClick={() => navigate("/integrations/wordpress-guide")}
            className="animate-blink-btn inline-flex items-center justify-center gap-2 self-start md:self-auto bg-gradient-to-r from-indigo-600 to-primary text-white px-5 py-3 rounded-lg font-semibold text-sm hover:-translate-y-0.5 transition-transform"
          >
            <Icon icon="mdi:book-open-page-variant" className="text-lg" />
            How to Use the Plugin
          </button>
        </div>
      </div>
    </Card>
  );
};

export default WordPressGuideBanner;
